module.exports = __webpack_public_path__ + "static/assets/282bbc05dcfeb12df60a63bafb2512ec.png";